import { useSelector } from "react-redux";
import useIsBraintreeEnabled from "@tvg/sh-lib-paws/hooks/useIsBraintreeEnabled";
import { getPmToggles } from "../utils";

/**
 * Returns the full payment-method toggle map. Braintree visibility (BTCC/BTDB)
 * resolves through the combined SGW + Amplitude gate; everything else comes
 * from the `getPmToggles` selector.
 */
export const useGetPmToggles = () => {
  const isBraintreeCCEnabled = useIsBraintreeEnabled();
  const baseToggles = useSelector(getPmToggles);

  return {
    ...baseToggles,
    BTCC: isBraintreeCCEnabled,
    BTDB: isBraintreeCCEnabled
  };
};

export default useGetPmToggles;
